export const UPLOAD_ORDERS_STEPS = ['Subir plantilla', 'Resumen'];
